// Apple Pay supported version
export const SUPPORTED_VERSION = 3;

/**
 * Check if Apple Pay is supported on the current device and browser
 * @returns {boolean} Whether Apple Pay is supported
 */
export const isApplePaySupported = (): boolean => {
  return (
    typeof ApplePaySession !== 'undefined' &&
    ApplePaySession &&
    ApplePaySession.supportsVersion(SUPPORTED_VERSION) &&
    ApplePaySession.canMakePayments()
  );
};
